// Firestore `in` queries cap at 30 values per clause.
export const FIRESTORE_IN_LIMIT = 30

export function chunk<T>(arr: T[], size: number): T[][] {
  const out: T[][] = []
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size))
  return out
}
